var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complete-registration"},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('v-img',{attrs:{"src":require("../assets/2025-home-header.png")}})],1)],1),_c('v-row',{staticClass:"mt-5"},[_c('v-col',{staticClass:"text-center"},[_c('heart-loader')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }